import { z } from "zod";

export const signInSchema = z.object({
  email: z.string().email().or(z.string().min(6)).or(z.string().max(255)),
  password: z.string().min(1),
  remmemberMe: z.boolean().optional(),
});

export type SignInSchema = z.infer<typeof signInSchema>;
